import { PostBoxDocument } from '@zero/postbox/domain';
import { Post } from '@zero/shared/util-models';
import { environment } from 'environments/environment';

export const getDocumentTitle = (document: PostBoxDocument | Post): string => {
  if (document.pdfTitle) {
    let ret = document.pdfTitle;
    if (document.pdfIsin) {
      const isins = document.pdfIsin.split(',');
      if (isins.length > 2) {
        ret += ` ${isins[0]}, ${isins[1]}, ...`;
      } else {
        ret += ` ${isins.join(', ')}`;
      }
    }
    return ret;
  }

  return document.title;
};

export const getPdfUriForDocument = (p: PostBoxDocument | Post, customerId: string): string => {
  return encodeURI(
    `${environment.apihost + environment.posteingangServiceUrl}/${customerId}/doc/${p.id}/${getDocumentTitle(p)
      .replace(',', '-')
      .replace(':', '_')
      .replace('/', '-')}.pdf`,
  );
};
